// Generated by Melange

import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function TisHypothetical(Props) {
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "Во время эксплуатации ТИС Бухта у вас могут возникать различные технические неисправности. Для сообщения о технической неисправности можете составить сообщение о неисправности и отправить его любым доступным вам способом: центр помощи, мессенджеры, офис.",
            className: "paragraph-small lg:flex lg:m-auto lg:w-200 text-gray-light-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "Если вы захотите отказаться от использования ТИС Бухта, вам необходимо обратиться к нам с заявкой на отключение системы. Вашу заявку мы обработаем в течение 3-х рабочих дней, после чего вам будет предоставлено соглашение о расторжении договора на использование ТИС Бухта.",
            className: "paragraph-small lg:w-200 lg:flex lg:mx-auto mt-2 text-gray-light-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "Договор на использование ТИС Бухта может быть расторгнут в случае неоплаты по договору использования ТИС в течение более чем 2-х месяцев.",
            className: "paragraph-small lg:w-200 lg:flex lg:mx-auto mt-2 text-gray-light-landing"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        alt: "lock",
                        src: StaticAsset.src("/static/icons/lock.svg")
                      }),
                      JsxRuntime.jsx("p", {
                        children: "Дата-центр с сертификацией ГТС",
                        className: "paragraph-small text-black-landing -mt-4"
                      }),
                      JsxRuntime.jsx("img", {
                        className: "mt-4",
                        alt: "layers",
                        src: StaticAsset.src("/static/icons/layers.svg")
                      }),
                      JsxRuntime.jsx("p", {
                        children: "Уровни доступа RBAC INCITS 359-2012",
                        className: "paragraph-small text-black-landing -mt-4"
                      })
                    ],
                    className: "flex flex-col items-center text-center w-36 mt-5.5"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        alt: "key",
                        src: StaticAsset.src("/static/icons/key.svg")
                      }),
                      JsxRuntime.jsx("p", {
                        children: "Платежный провайдер с сертификацией PCI-DSS",
                        className: "paragraph-small text-black-landing -mt-4"
                      }),
                      JsxRuntime.jsx("img", {
                        className: "mt-4",
                        src: StaticAsset.src("/static/icons/security.svg")
                      }),
                      JsxRuntime.jsx("p", {
                        children: "Целостность и конфиденциальность данных ISO/IEC 13335-1:2004",
                        className: "paragraph-small text-black-landing -mt-4",
                        alt: "text black landing"
                      })
                    ],
                    className: "flex flex-col items-center text-center w-36 -mt-2"
                  })
                ],
                className: "flex justify-between sm:justify-around lg:w-96"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h6", {
                    children: "Взаимодействие со сторонними системами",
                    className: "h6 text-black-landing"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "ТИС Бухта поддерживает сторонние интеграции. Проведение сторонней интеграции возможно по вашей заявке, либо по решению ТОО “Бухта”.",
                    className: "paragraph text-gray-landing mt-2 lg:mt-4"
                  }),
                  JsxRuntime.jsx("p", {
                    children: "При проведении интеграции используются API и протоколы, не позволяющие вносить изменения в данные, которые могут повлиять на корректность предоставляемой информации.",
                    className: "paragraph text-gray-landing mt-2 lg:mt-4"
                  })
                ],
                className: "mt-8 lg:mt-0 lg:w-96"
              })
            ],
            className: "lg:flex lg:m-auto mt-6 lg:mt-20 justify-between lg:w-200"
          }),
          JsxRuntime.jsx("p", {
            children: "Для интеграции необходимо обратиться к нам любым удобным вам способом. Заявка рассматривается в течение 10-ти рабочих дней. По результату рассмотрения предоставим ответ.",
            className: "paragraph-small lg:flex lg:m-auto mt-6 lg:mt-20 lg:w-200 text-gray-light-landing"
          })
        ],
        className: "p-6 lg:py-20 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/guard-circled.svg")
          }),
          JsxRuntime.jsx("h3", {
            children: "Гарантийные случаи ТИС",
            className: "h4 lg:h3 text-center text-black-landing lg:mt-4"
          }),
          JsxRuntime.jsx("p", {
            children: "В случае возникновения ошибок и неисправностей в процессе эксплуатации ТИС Бухта, это рассматривается как гарантийный случай и устраняется за наш счет по результатам рассмотрения неисправности.",
            className: "paragraph lg:h-light text-center text-gray-landing lg:w-192 mt-2"
          })
        ],
        className: "flex m-auto mt-4 lg:mt-20 flex-col items-center lg:rounded-sm lg:w-252 bg-bg pt-8 pb-10 px-6 lg:pt-18 lg:pb-20 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: Buhta_landing__I18n.trans(intl, "help_center"),
                className: "h4 lg:h3 text-error-variant text-center lg:text-left"
              }),
              JsxRuntime.jsx("p", {
                children: "Через центр помощи вы можете подать заявку на подключение к системе ТИС и на дальнейшее взаимодействие по ее эксплуатации.",
                className: Cn.fromList({
                  hd: "paragraph lg:h-light opacity-64 text-error-variant text-center lg:text-left mt-2 lg:w-130",
                  tl: /* [] */ 0
                })
              }),
              JsxRuntime.jsx("p", {
                children: "Центр помощи доступен с 9:00 до 21:00 по времени г. Нур-Султан.",
                className: "paragraph-small text-error-variant opacity-40 mt-2 text-center lg:text-left"
              }),
              JsxRuntime.jsxs("a", {
                children: [
                  "Подать заявку",
                  JsxRuntime.jsx("img", {
                    className: "inline ml-1",
                    src: StaticAsset.src("/static/icons/forward-pink.svg")
                  })
                ],
                className: "text-center lg:text-left block paragraph cursor-pointer link-hover text-error-variant mt-6 lg:mt-20"
              })
            ],
            className: "pt-10 lg:pt-16 px-6 sm:px-48 lg:pr-0 lg:pl-18 lg:pb-16"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              alt: "support",
              src: StaticAsset.src("/static/images/support.png")
            }),
            className: "flex m-auto lg:block lg:m-0 w-61.25 h-79.75 lg:h-auto lg:w-78.5 lg:ml-25.5"
          })
        ],
        className: "lg:w-304 lg:flex lg:m-auto lg:mt-20 lg:rounded-sm lg:mb-20 bg-black-landing"
      })
    ]
  });
}

const make = TisHypothetical;

export {
  make,
}
/* react Not a pure module */
